import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { TAX_BREAKDOWN_TABLE } from './taxRules';

const TAX_BREAKDOWN_SOURCE_URL =
  'https://aussiecommerce.atlassian.net/wiki/spaces/SO/pages/2289500200/Tax+Breakdown+by+Country';

interface Props {
  onClose: () => void;
  open: boolean;
}

export default function TaxBreakdownDialog({ onClose, open }: Props) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Tax breakdown by country</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Location</TableCell>
                <TableCell>Tax/fee</TableCell>
                <TableCell align="right">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {TAX_BREAKDOWN_TABLE.map((row, index) => (
                <TableRow key={`${row.location}-${row.name}-${index}`}>
                  <TableCell>{row.location}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell align="right">
                    {typeof row.rate === 'number' ? `${row.rate}%` : `${row.amount} ${row.currency}`}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Link href={TAX_BREAKDOWN_SOURCE_URL} target="_blank" rel="noopener noreferrer" variant="body2">
          View full details on Confluence
        </Link>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
